<template lang="pug">
  #fans.view( v-show='filtered.length' )
    customer-card.customers(
      v-for='c in filtered'
      :key='c.id'
      :cus='c'
      :biz='biz'
      :user='user'
      :account='account'
      :filters='filters'
    )
</template>

<script>
  import CustomerCard from '@/components/customer-card'
  import { db } from '@/main'

  export default {
    name: 'fans.view',

    components: {
      CustomerCard
    },

    props: {
      items: { type: Array },
      biz: { type: Object },
      user: { type: Object },
      account: { type: Object },
      rsvs: { type: Array },
      filters: { type: Array }
    },

    data() {
      return {
      }
    },

    computed: {
      filtered() {
        return this.items.filter( c => this.rsvs.map( r => r.account_id ).includes( c.account_id ) )
      }
    }
  }
</script>